class Video {
	constructor() {
		this.video = document.querySelector('.js-video')
		this.wrapper = document.querySelector('.js-video__wrapper')
		this.controls = document.querySelector('.js-video__controls')
		this.wrapperHeight = this.wrapper.offsetHeight
		this.wrapperWidth = this.wrapper.offsetWidth
		this.mousePosition = {}

		this.setControlsSize()
	}

	startListen() {
		this.wrapper.addEventListener('mousemove', this.render.bind(this))
	}

	stopListen() {
		this.wrapper.removeEventListener('mousemove', this.render.bind(this))
	}

	render(e) {
		this.getMousePosition(e)
		this.moveVideo()
		this.setControlsSize()
	}

	setControlsSize() {
		this.controls.style.width = this.video.offsetWidth + 'px'
		this.controls.style.height = this.video.offsetHeight + 'px'
	}

	getWrapperCenter() {
		return {
			x : this.wrapperWidth / 2,
			y : this.wrapperHeight / 2,
		}
	}

	getMousePosition(e) {
		let wrapperTop = this.wrapper.offsetTop
		this.mousePosition = {
			x : e.clientX,
			y : e.clientY - wrapperTop,
		}
	}

	getMouseGapFromCenter() {
		let center = this.getWrapperCenter()

		return {
			x : center.x - this.mousePosition.x,
			y : center.y - this.mousePosition.y,
		}
	}

	moveVideo() {
		let mouseGap = this.getMouseGapFromCenter()
		let ratio = {
			x : this.video.offsetWidth / this.wrapper.offsetWidth,
			y : this.video.offsetHeight / this.wrapper.offsetHeight,
		}
		let futureX = (mouseGap.x * ratio.x) - (this.video.offsetWidth / 2)
		let futureY = (mouseGap.y * ratio.y) - (this.video.offsetHeight / 2)
		let x = futureX
		let y = futureY

		// Right
		let maxRight = this.video.offsetWidth - (this.wrapper.offsetWidth / 2)
		if (futureX < -maxRight) {
			x = -maxRight
		}

		// Left
		let maxLeft = (this.wrapper.offsetWidth / 2)
		if (futureX > -maxLeft) {
			x = -maxLeft
		}

		// Bottom
		let maxBottom = this.video.offsetHeight - (this.wrapper.offsetHeight / 2)
		if (futureY < -maxBottom) {
			y = -maxBottom
		}

		// Top
		let maxTop = this.wrapper.offsetHeight / 2
		if(futureY  > - maxTop) {
			y = -maxTop
		}

		const translate = "translate(" + x + "px," + y + "px)";

		setVendor(this.video, "Transform", translate);
		setVendor(this.controls, "Transform", translate);

		//this.video.style.transform = 'translate(' + x + 'px,' + y + 'px)'
		//this.controls.style.transform = 'translate(' + x + 'px,' + y + 'px)'
	}
}

function setVendor(element, property, value) {
	element.style["webkit" + property] = value;
	element.style["moz" + property] = value;
	element.style["ms" + property] = value;
	element.style["o" + property] = value;
}

export default Video;



// WEBPACK FOOTER //
// ./src/js/clone-v2/video.js